var React = require('react');

function IconDailyAverageAdjustment (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M601.6 240.65l-334.2 302c-10.47 9.46-27.45 9.46-37.93 0s-10.47-24.81 0-34.28l334.19-302c10.47-9.47 27.46-9.47 37.93 0s10.47 24.81 0 34.27zm-10.12 137.74l147.64-133.23c49.85-45 49.85-118.15 0-163.16s-130.93-45-180.8 0L410.68 215.23c-10.55 9.53-27.67 9.53-38.23 0s-10.55-25 0-34.49L520.1 47.5c71.13-63.56 185.81-63.3 256.6.57s71.1 167.36.68 231.57L629.74 412.87c-10.56 9.53-27.68 9.53-38.23 0s-10.56-25 0-34.49zm-173 156.11c10.62-9.2 27.45-9 37.85.35s10.56 24.59.35 34.16L309 702.26c-71.23 62.84-185.27 62.24-255.72-1.35s-71.11-166.49-1.47-230.81l147.64-133.23c10.56-9.52 27.67-9.52 38.23 0s10.56 25 0 34.5L90 504.6c-49.84 45-49.87 118.18 0 163.16s131 45 180.8 0z"}));
}

IconDailyAverageAdjustment.displayName = "IconDailyAverageAdjustment";

IconDailyAverageAdjustment.defaultProps = {"data-name":"图层 1","viewBox":"0 0 829.99 749"};

module.exports = IconDailyAverageAdjustment;

IconDailyAverageAdjustment.default = IconDailyAverageAdjustment;
